import React, {Component} from "react";
import {Button, Glyphicon, PageHeader} from "react-bootstrap";
import "./Orders.css";
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import * as userLib from "../libs/user-lib";
import {columnDefsOrders} from "../libs/columnDefOrders";
import {orderID} from "../libs/globalDefOrders";
const API = require("../libs/awsApiWrappers");

export default class Orders extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            users: [],
            selectedOrders: [],
            isEditor: userLib.isCustomEditor(this.props.currentUser, 'order'),
            isViewer: userLib.isCustomViewer(this.props.currentUser, 'order'),

            columnDefs: columnDefsOrders,

            defaultColDef: {
                sortable: true,
                filter: true,
                lockPinned: true,
                resizable: true
            },
            style: {
                width: '100%',
                height: '644px'
                // height: '364px'
                // height: '2884px'
            },
            rowSelection: "single",
            paginationPageSize: 100,
            paginationNumberFormatter: function (params) {
                return params.value.toLocaleString();
            }
        };

        this.state.columnDefs[0].checkboxSelection = true;
        const self = this;
        this.state.columnDefs[0].cellRenderer = API.getCustomCellRenderer("orders", self,
            () => { self.props.setOrderToDuplicate(null) }, orderID);

    }

    onGridReady = params => {
        this.gridApi = params.api;
        // this.gridColumnApi = params.columnApi;

        const updateData = data => {
            this.props.setRowDataOrders(data);
            params.api.paginationGoToPage(0);
        };

        updateData(this.props.rowDataOrders);
        const value = this.props.searchBoxValue;
        const box = document.getElementById('filter-text-box');
        if (box) {
            box.value = value;
        }
        params.api.setGridOption("quickFilterText", value);

        const valuePageSize = this.props.pageSize;
        document.getElementById("page-size").value = valuePageSize;
        this.gridApi.setGridOption("paginationPageSize", Number(valuePageSize));
    };


    onPageSizeChanged() {
        // const pxPerRow = 28;
        const value = document.getElementById("page-size").value;
        this.props.setPageSize(value);
        this.gridApi.setGridOption("paginationPageSize", Number(value));

        // const newHeight = ((Number(value) + 3) * pxPerRow).toString() + "px";
        // this.setHeight(newHeight);
    }

    onSelectionChanged() {
        this.setState({selectedOrders: this.gridApi.getSelectedRows()});
    }

    componentDidUpdate() {
        if (this.gridApi) {
            this.gridApi.refreshCells();
        }
    }

    async componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        this.setState({isEditor: userLib.isCustomEditor(this.props.currentUser, 'order')});
        this.setState({isViewer: userLib.isCustomViewer(this.props.currentUser, 'order')});

        if (this.props.rowDataOrders.length === 0) {
            try {
                const orders = await this.orders("");
                let tempResult = orders;
                while (tempResult.LastEvaluatedKey) {
                    tempResult = await this.orders(tempResult.LastEvaluatedKey);
                    orders.Items = orders.Items.concat(tempResult.Items);
                }
                this.props.setRowDataOrders(orders.Items);
                this.setState({isEditor: userLib.isCustomEditor(this.props.currentUser, 'order')});
                this.setState({isViewer: userLib.isCustomViewer(this.props.currentUser, 'order')});
            } catch (e) {
                API.handleApiErrorWithAlert(e, this);
            }
        } else {
            this.setState({isEditor: userLib.isCustomEditor(this.props.currentUser, 'order')});
            this.setState({isViewer: userLib.isCustomViewer(this.props.currentUser, 'order')});

        }
        this.props.setUpdateTimeOutListener();
        this.setState({isLoading: false});
    }

    orders(lastEvaluatedKey) {
        let myInit = {
            queryStringParameters: {}
        };
        if (lastEvaluatedKey && ("" !== lastEvaluatedKey.customerEmail)) {
            myInit.queryStringParameters.ExclusiveStartKey = lastEvaluatedKey.customerEmail;
            myInit.queryStringParameters.ExclusiveStartKey1 = lastEvaluatedKey.orderTime;
        }
        return API.get("pumps", "/orders", myInit);
    }

    onFilterTextBoxChanged() {
        if (this.gridApi) {
            const value = document.getElementById('filter-text-box').value;
            this.props.setSearchBox(value);
            this.gridApi.setGridOption("quickFilterText", value);
        }
    }

    onAddOrder() {
        this.props.setOrderToDuplicate(null);
        this.props.history.push('/orders/new');
    }

    onDuplicateOrder() {
        this.props.setOrderToDuplicate(this.state.selectedOrders);
        this.props.history.push('/orders/new');
    }

    onBtExport() {
        const params = {
            skipHeader: false,
            skipFooters: false,
            skipGroups: false,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: true,
            onlySelected: false,
            suppressQuotes: true,
            fileName: "CamAPS orders",
            columnSeparator: ',',
            customHeader: "CamAPS orders\n"
        };
        this.gridApi.exportDataAsCsv(params);
    }

    renderOrdersList() {
        return (
            <div style={{width: "100%", height: "100%"}}>
                <div className="pump-container">
                    <div className="page-container">
                        {this.state.isEditor ?
                            <Button className="button-add pull-left" bsStyle="primary" bsSize="small"
                                    onClick={this.onAddOrder.bind(this)}>
                                Add order
                            </Button> : null
                        }
                        {this.state.isEditor ?
                            <Button className="button-duplicate pull-left" bsStyle="primary" bsSize="small"
                                    margin-left={20}
                                    disabled={this.state.selectedOrders.length === 0}
                                    hidden={this.state.isEditor}
                                    onClick={this.onDuplicateOrder.bind(this)}>
                                Duplicate order
                            </Button> : null
                        }
                        <Button className="pull-right" bsStyle="info" bsSize="small"
                                onClick={this.onBtExport.bind(this)}>
                            <Glyphicon glyph="file"/> Export to Excel
                        </Button>
                    </div>
                    <div className="page-container">
                        <div className="page-size-header pull-left">
                            Page size:&nbsp;
                            <select onChange={this.onPageSizeChanged.bind(this)} id="page-size" defaultValue={'100'}>
                                {/*<select id="page-size" defaultValue={'100'}>*/}
                                <option value="10">10</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                                <option value="1000">1000</option>
                            </select>
                        </div>
                        <input className="pull-right" type="text" id="filter-text-box" placeholder="Search..."
                               onInput={this.onFilterTextBoxChanged.bind(this)}/>
                    </div>
                    <div style={{minHeight: "400px", height: "calc(100% - 30px)"}}>
                        <div
                            id="usersGrid"
                            style={this.state.style}
                            className="ag-theme-balham"
                        >
                            <AgGridReact
                                columnDefs={this.state.columnDefs}
                                defaultColDef={this.state.defaultColDef}
                                rowSelection={this.state.rowSelection}
                                onGridReady={this.onGridReady}
                                enableCellTextSelection={true}
                                onSelectionChanged={this.onSelectionChanged.bind(this)}
                                pagination={true}
                                paginationPageSize={this.state.paginationPageSize}
                                paginationNumberFormatter={this.state.paginationNumberFormatter}
                                rowData={this.props.rowDataOrders}
                                headerHeight={58}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderLander() {
        return (
            <div className="lander">
                <h1>Access not allowed. Not authenticated</h1>
            </div>
        );
    }

    getHeader() {
        if (this.state.isLoading) {
            return ('Loading ...');
        } else if (!this.props.rowData || (this.props.rowData.length === 0)) {
            return ('CamAPS orders');
        } else {
            return ('All CamAPS orders');
        }
    }

    // getUser() {
    //     try {
    //         return ('User: ' + this.props.currentUser.attributes.name);
    //     } catch (e) {
    //         return ('');
    //     }
    // }

    renderOrders() {
        return (
            <div className="pumps">

                {/*<div className="left-header pull-left">*/}
                <PageHeader>
                    <div className="header">
                        <div className="left-header pull-left">
                            {this.getHeader()}
                        </div>
                        {/*<div className="pull-right">*/}
                        {/*    <h4 className="text-right">*/}
                        {/*        {this.getUser()}*/}
                        {/*    </h4>*/}
                        {/*</div>*/}
                        <div className="clearfix"/>
                    </div>
                </PageHeader>
                {!this.state.isLoading && this.renderOrdersList()}
            </div>
        );
    }

    render() {
        return (
            <div className="Home">
                {this.props.isAuthenticated ? this.renderOrders() : this.renderLander()}
            </div>
        );
    }
}
